import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { CognitoConfig } from '../Environments/configs';
import { setToLocalStorage } from '../Helpers/helpers';
import { error } from '../Helpers/notification';
import { login } from '../Redux/features/auth.slice';
import { setPageLoader } from '../Redux/features/utils.slice';
import { pageRoutes } from '../Routing/pageRoutes';
import { errorFactory, ErrorHandling } from './errorHandling';
import { tokenId } from '../Environments/environment';
const { userPool } = CognitoConfig;
const cognitoLogin = async (body, dispatch, navigate) => {
  
  dispatch(setPageLoader({ page: 'login', flag: true }))
  let { username, password } = body;
  let cognitoUserPool = new CognitoUserPool(userPool)
  const user = new CognitoUser({
    Username: username,
    Pool: cognitoUserPool,
  });
  const authDetails = new AuthenticationDetails({
    Username: username,
    Password: password,
  });
  user.authenticateUser(authDetails, {
    onSuccess: (result) => {
      // console.log({ result })
      let userDetails = {
        username,
        accessToken: result?.accessToken?.jwtToken,
      }
      localStorage.setItem(`authToken-${tokenId}`, JSON.stringify(result?.idToken?.jwtToken))
      setToLocalStorage(userDetails, 'user')
      dispatch(login(userDetails))
      navigate(pageRoutes.dashboard)
      dispatch(setPageLoader({ page: 'login', flag: false }))
    },
    onFailure: (err) => {
      console.log({ err })
      error(err.message, 'Authentication Failed!')
      dispatch(setPageLoader({ page: 'login', flag: false }))
    }
  })

}


export {
  cognitoLogin
}